import { ref } from "vue";

export function useRecaptcha(siteKey = null) {
  const recaptchaToken = ref(null);
  const recaptchaError = ref(null);
  const recaptchaSiteKey = ref(
    siteKey ||
      window.andalePluginsStockNotificationsPublic?.recaptchaSiteKey ||
      null,
  );

  // const executeRecaptcha = async () => {
  //   if (!recaptchaSiteKey) {
  //     console.warn("Recaptcha site key is not set.");
  //     return;
  //   }

  //   try {
  //     recaptchaToken.value = await grecaptcha.execute(recaptchaSiteKey, {
  //       action: "submit",
  //     });
  //     recaptchaError.value = null;
  //   } catch (error) {
  //     console.error("Recaptcha execution failed:", error);
  //     recaptchaError.value = "Recaptcha verification failed. Please try again.";
  //   }
  // };
  const executeRecaptcha = async (action = "submit") => {
    recaptchaError.value = null;
    try {
      if (!window.grecaptcha || !window.grecaptcha.execute) {
        throw new Error("reCAPTCHA is not loaded.");
      }

      const token = await window.grecaptcha.execute(recaptchaSiteKey.value, {
        action,
      });
      console.log("reCAPTCHA token:", token);
      recaptchaToken.value = token;
      recaptchaError.value = null;

      return token;
    } catch (error) {
      console.error("Error executing reCAPTCHA:", error);
      recaptchaToken.value = null;
      recaptchaError.value = "Recaptcha verification failed. Please try again.";
      return null;
    }
  };

  return {
    recaptchaToken,
    recaptchaError,
    executeRecaptcha,
  };
}
